import { Avatar } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface InitialAvatarProps {
  name?: string | null;
  /** Exact single letter/initial overrides computed initials. */
  letter?: string;
  size?: number;
  sx?: SxProps<Theme>;
}

/** Legacy Poseidon convention: initial-letter circle avatar (no image). */
export function InitialAvatar({ name, letter, size = 36, sx }: InitialAvatarProps) {
  const text = letter ?? nameInitials(name);
  return (
    <Avatar
      aria-hidden
      sx={{
        width: size,
        height: size,
        fontSize: Math.max(12, Math.round(size * 0.4)),
        fontWeight: 700,
        bgcolor: 'primary.main',
        color: '#fff',
        flexShrink: 0,
        ...sx,
      }}
    >
      {text}
    </Avatar>
  );
}

function nameInitials(name?: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
}
